var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMoreArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14797_2677",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "matrix(-1 0 0 1 18 0)",
    fill: "#9F9F9F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14797_2677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1316 9.7501L8.45664 13.4251C8.30664 13.5751 8.23476 13.7501 8.24101 13.9501C8.24726 14.1501 8.32539 14.3251 8.47539 14.4751C8.62539 14.6126 8.80039 14.6845 9.00039 14.6907C9.20039 14.697 9.37539 14.6251 9.52539 14.4751L14.4754 9.5251C14.5504 9.4501 14.6035 9.36885 14.6348 9.28135C14.666 9.19385 14.6816 9.1001 14.6816 9.0001C14.6816 8.9001 14.666 8.80635 14.6348 8.71885C14.6035 8.63135 14.5504 8.5501 14.4754 8.4751L9.52539 3.5251C9.38789 3.3876 9.21602 3.31885 9.00977 3.31885C8.80351 3.31885 8.62539 3.3876 8.47539 3.5251C8.32539 3.6751 8.25039 3.85322 8.25039 4.05947C8.25039 4.26572 8.32539 4.44385 8.47539 4.59385L12.1316 8.2501H3.75039C3.53789 8.2501 3.35976 8.32197 3.21601 8.46572C3.07226 8.60947 3.00039 8.7876 3.00039 9.0001C3.00039 9.2126 3.07226 9.39072 3.21601 9.53447C3.35976 9.67822 3.53789 9.7501 3.75039 9.7501H12.1316Z",
    fill: "#9F9F9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMoreArrowBack);
export default __webpack_public_path__ + "static/media/view-more-arrow-back.26c3c8358566ac6e29f66f1d9f6ec0c6.svg";
export { ForwardRef as ReactComponent };